import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

const theme = createTheme({
    palette: {
        mode: 'light'
    },
    centercontent: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                html: {
                    height: '100%'
                },
                body: {
                    height: '100%',
                    backgroundColor: 'rgb(231, 235, 240)',
                    '& #root': {
                        height: '100%',
                        minHeight: 600,
                        overflow: 'hidden'
                    }
                }
            },
        },
    },
});

const Theme = ({children}) => {

    return (<ThemeProvider theme={theme} >
        <CssBaseline />
        {children}
    </ThemeProvider>);
}

export default Theme;